import { PageLayout } from '../../../core/types/Typesetter';
import { buildParagraphToPageMap } from './ParagraphToPageMapper';
import { sampleMapEntries } from '../utils';
import { WasmLogger } from '../../../../../utils/loggers/WasmLogger';

/**
 * ParagraphToPageMapBuilder - Utility for building and updating paragraph-to-page mappings
 *
 * Handles the construction and assignment of paragraph-to-page mappings from
 * PageLayout results. Used during pagination to track which pages contain
 * which paragraphs for SpillFrontier calculations and incremental updates.
 */
export class ParagraphToPageMapBuilder {
  /**
   * Build paragraph-to-page mapping from PageLayout array
   *
   * This method constructs a mapping from paragraph IDs to arrays of page indices
   * that contain slices of those paragraphs. This mapping is essential for
   * incremental pagination to determine SpillFrontiers and affected page ranges.
   *
   * @param pages - Array of PageLayout objects from pagination result
   * @param paragraphToPageMap - Map to update with paragraph-to-page relationships (will be replaced)
   */
  static buildParagraphToPageMap(
    pages: PageLayout[],
    paragraphToPageMap: Map<string, number[]>
  ): void {
    // Build the map using extracted utility function
    const newMap = buildParagraphToPageMap(pages);

    // Replace the map with the new mapping
    paragraphToPageMap.clear();
    for (const [key, value] of newMap.entries()) {
      paragraphToPageMap.set(key, value);
    }

    WasmLogger.pagination.paragraphMapBuilt(paragraphToPageMap.size, sampleMapEntries(paragraphToPageMap, 3));
  }
}
